import { useRef } from 'react';
import Icon from '../../Icon/Icon';
import bem from '../../../../utils/bem';

const Select = ({ settings, onChange }) => {
  const selectWrapper = useRef(null);
  const select = useRef(null);
  const baseClass = 'form-item';
  const {
    name,
    placeholder = '',
    label,
    state = {},
    options,
    wrapperClasses = [],
    hideLabel,
    hidden = false,
  } = settings || {};

  if (!options || !options.length || hidden) {
    return '';
  }
  return (
    <div
      className={bem(baseClass, ['select'], '', wrapperClasses)}
      ref={selectWrapper}
    >
      {label && (
        <label className={hideLabel ? 'visually-hidden' : ''} htmlFor={name}>
          {label}
        </label>
      )}

      <div className="select-wrapper">
        <select
          ref={select}
          className="select"
          name={name}
          id={name}
          onChange={onChange}
          placeholder={placeholder}
          value={state[`${name}`]}
          data-filter-type="select"
        >
          {options.map((option) => {
            return (
              <option
                key={option.value ? option.value : `${name}-empty`}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            );
          })}
        </select>
        <Icon iconName="chevron" />
      </div>
    </div>
  );
};

export default Select;
